import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { COLLABORATOR_I18N_KEY } from "./constants";
var en = /*#__PURE__*/_defineProperty({}, COLLABORATOR_I18N_KEY, {
  KH_CLOSE: 'Close',
  KH_LAST_UPDATED: 'Last updated on: {{date}}',
  KH_MODULES: 'Modules',
  KH_RATING: 'Rating',
  KH_STUDENTS: 'Students',
  KH_COURSE_SEE_DETAIL: 'See detail',
  KH_SEE_CATALOG: 'See catalog',
  KN_DOCUMENT: 'Document',
  KN_DOWNLOAD: 'Download',
  KH_COURSE_ENROLL: 'Enroll',
  KH_SEARCH: 'Search',
  KH_FILTER_CATEGORY_ALL: 'All',
  KH_SEARCH_SUCCESS_RESULTS: 'Search results',
  KH_SEARCH_NO_RESULTS: 'No results found',
  KH_SEARCH_X_RESULTS: '{{count}} result',
  KH_SEARCH_X_RESULTS_plural: '{{count}} results',
  KH_SEARCH_NO_RESULTS_FOR: 'No results found for "{{query}}"',
  KH_SEARCH_NO_RESULTS_ACTION: 'Try another word',
  KH_SEARCH_PLACEHOLDER: 'What do you want to search?',
  KH_SEARCH_PLACEHOLDER_SHORT: 'What are you looking for?',
  KH_SEARCH_CLEAR: 'Clear search',
  KH_FILTER_TITLE: 'Filters',
  KH_FILTER_CTA: 'Filter',
  KH_FILTER_ITEM_CATEGORIES: 'Categories',
  KH_FILTER_ITEM_PROVIDER: 'Partners',
  KH_FILTER_ITEM_LEVELS: 'Levels',
  KH_FILTER_ITEM_LANGUAGES: 'Languages',
  KH_FILTER_ITEM_CONTENT_TYPES: 'Content type',
  KH_FILTER_INITIAL_CTA: 'Filter by',
  KH_FILTER_VIEW_ALL: 'View all',
  KH_SORTING_INITIAL_CTA: 'Sort by',
  KH_SORTING_AZ: 'From A-Z',
  KH_SORTING_ZA: 'From Z-A',
  KH_COURSE: 'Course',
  KH_CONTENTS_CATEGORY_LABEL: 'Contents',
  KH_CONTENT_CATEGORY_LABEL: 'Content',
  KH_BREADCRUMB_HOME: 'Home',
  KH_BREADCRUMB_CATALOG: 'Catalog',
  KH_BREADCRUMB_INTEREST_CONTENT: 'Content of Crehana',
  KH_BREADCRUMB_ONLY: 'Content of {{name}}',
  KH_BREADCRUMB_THIRD_PARTY_CONTENT: 'External contents',
  KH_COME_BACK: 'Back',
  KH_ERROR_VIEW_MESSAGE: 'Oops! Something went wrong. Please reload the page. If the problem persists, contact support.',
  KH_ERROR_VIEW_SHOW_ERROR: 'Show error',
  KH_ERROR_VIEW_HIDE_ERROR: 'Hide error',
  KH_ERROR_VIEW_TRY_AGAIN: 'Reload page',
  KH_NO_DATA_LOADED_ERROR_MESSAGE: 'Sorry, no categories or available courses were found. This may be due to the categories not being loaded correctly or not containing any courses. Please contact the platform administrator to resolve the issue.',
  KH_CONTENT_OF_INTEREST_TITLE: 'Content of Crehana',
  KH_THIRD_PARTY_CONTENT_TITLE: 'Content of Partners',
  KH_COURSES_DYNAMIC: '{{count}} course',
  KH_COURSES_DYNAMIC_plural: '{{count}} courses',
  KH_TEXT_TRACK: 'Track',
  KH_HOME_ORG_CATEGORY_TITLE: 'Content of {{organizationName}}',
  KH_HOME_CREHANA_CATEGORY_TITLE: 'Content of Crehana',
  KH_HOME_PARTNER_CATEGORY_TITLE: 'Content of Partners',
  KH_HOME_ORG_VIEW_ALL_CATALOG: 'Enter all the **{{organizationName}}** catalog',
  KH_HOME_CREHANA_VIEW_ALL_CATALOG: 'All the **Crehana** catalog in one place',
  KH_HOME_PARTNER_VIEW_ALL_CATALOG: 'Get trained by the hand of our **partners**',
  KH_HOME_SUMMARY_CREHANA_CARD: 'Crehana',
  KH_HOME_SUMMARY_PARTNER_CARD: 'Partners',
  KH_HOME_CONTENTS_LABEL: 'contents',
  KH_HOME_COURSES_LABEL: 'courses',
  KH_SUBCATEGORY_IS_NEW_LABEL: 'New',
  DUD_DOCUMENTS_PREVIEW_CTA: 'View',
  KH_DOCUMENT_PREVIEW_TITLE: 'Preview of *{{documentName}}*',
  KN_DOCUMENT_PREVIEW_ERROR_MESSAGE: 'Your browser does not support the display of PDFs. Download the document in PDF.',
  KN_DOCUMENT_PREVIEW_ERROR_SUBTITLE: 'The preview of this document is not available',
  KN_DOCUMENT_PREVIEW_ERROR_DESCRIPTION: 'An unexpected error occurred or the format you want to view is not compatible with this viewer. Click the button to try to load again.',
  KN_DOCUMENT_PREVIEW_ERROR_CTA: 'Understood',
  KN_DOCUMENT_PREVIEW_ERROR_RETRY: 'Retry',
  KH_REQUIRED: 'Required',
  KH_VIRTUAL: 'Virtual',
  KH_IN_PERSON: 'In-person'
});
export default en;